/* Prices in the shopper's own number format on the translated storefronts.
   Shopify prints every price in the currency's default shape ("$22.00", "CAD 1.60", "QAR 74,00", "BRL 16.99")
   whatever the language. Quebec French writes "22,00 $", Brazil "R$ 16,99", the Gulf sites "QAR 74.00".
   This rewrites price text once the page is drawn and again whenever the page changes (cart drawer, variant
   change, load more). Loaded by layout/theme.liquid for every language except English. */
(function () {
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  var loc = lang.slice(0, 2);
  if (!loc || loc === 'en') return;

  var NBSP = ' ', NNBSP = ' ';

  function group(intPart, sep) {
    return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  // Each rule: a pattern over the text as Shopify prints it, and the local shape
  var rules = {
    fr: [
      // "$22.00", "CA$22.00", "$1,750", "CAD 1.60", "22.00 CAD"
      { re: /(?:CA\$|\$|CAD)\s?(\d[\d,]*)(?:\.(\d{2}))?(?!\d)|(?<![\d,])(\d[\d,]*)\.(\d{2})\s?CAD/g,
        out: function (m, i1, d1, i2, d2) {
          var i = (i1 || i2).replace(/,/g, ''), d = d1 || d2;
          return group(i, NNBSP) + ',' + (d || '00') + NBSP + '$';
        } }
    ],
    pt: [
      // "BRL 16.99", "R$1.750" (missing space)
      { re: /BRL\s?(\d[\d,]*)\.(\d{2})(?!\d)/g,
        out: function (m, i, d) { return 'R$' + NBSP + group(i.replace(/,/g, ''), '.') + ',' + d; } },
      { re: /R\$(?=\d)/g, out: function () { return 'R$' + NBSP; } },
      // whole amounts ("R$ 1.750", "R$ 0") get their cents
      { re: /R\$[\u00a0 ]?(\d{1,3}(?:\.\d{3})*)(?![\d.]|,\d)/g, out: function (m, i) { return 'R$' + NBSP + i + ',00'; } }
    ],
    ar: [
      // "QAR 74,00", "SAR 1.716,00", "BHD 7,500": European punctuation in the Gulf; the decimals keep their length
      { re: /\b(QAR|SAR|BHD|KWD|OMR|AED)\s?(\d[\d.]*),(\d{2,3})(?!\d)/g,
        out: function (m, c, i, d) { return c + NBSP + group(i.replace(/\./g, ''), ',') + '.' + d; } },
      // whole amounts ("QAR 422", "QAR 0") get their cents; "SAR 1.716" is a thousands group, not a decimal
      { re: /\b(QAR|SAR|AED)\s?(\d{1,3}(?:[.,]\d{3})*)(?![\d.]|,\d)/g,
        out: function (m, c, i) { return c + NBSP + group(i.replace(/[.,]/g, ''), ',') + '.00'; } },
      // "ml" on its own (the unit-price span) and "10ml" sizes → "مل"
      { re: /(\d)\s?ml\b/g, out: function (m, d) { return d + ' مل'; } },
      { re: /(^|[\s/])ml\b/g, out: function (m, p) { return p + 'مل'; } },
      // Bahrain/Kuwait/Oman are priced in pounds, Saudi prints "SR": whole amounts get their cents
      { re: /£(\d[\d,]*)(?![\d.])/g, out: function (m, i) { return '£' + i + '.00'; } },
      { re: /\bSR\s?(\d[\d.]*),(\d{2})(?!\d)/g, out: function (m, i, d) { return 'SR' + NBSP + group(i.replace(/\./g, ''), ',') + '.' + d; } },
      { re: /\bSR\s?(\d{1,3}(?:[.,]\d{3})*)(?![\d.]|,\d)/g, out: function (m, i) { return 'SR' + NBSP + group(i.replace(/[.,]/g, ''), ',') + '.00'; } },
      // Saudi prints the code after the amount ("0 SR", "72 SR", "112.00 SR", "1.716,00 SR")
      { re: /(?<![\d.,])(\d[\d.]*),(\d{2})\s?SR\b/g, out: function (m, i, d) { return group(i.replace(/\./g, ''), ',') + '.' + d + NBSP + 'SR'; } },
      { re: /(?<![\d.,])(\d{1,3}(?:,\d{3})*)\s?SR\b/g, out: function (m, i) { return i + '.00' + NBSP + 'SR'; } }
    ]
  };
  rules.da = [
    // the per-ml line prints the ISO code: "DKK 12.90" → "12,90 kr"
    { re: /\bDKK\s?(\d[\d,]*)\.(\d{2})(?!\d)/g, out: function (m, i, d) { return i.replace(/,/g, '.') + ',' + d + NBSP + 'kr'; } },
    // "129 kr", "1.750 kr" (whole amounts) → "129,00 kr"; amounts with øre are already right
    { re: /(?<![\d,])(\d{1,3}(?:\.\d{3})*)\s?kr\b(?!\.)/g, out: function (m, i) { return i + ',00' + NBSP + 'kr'; } },
    { re: /(?<![\d,])(\d{1,3}(?:\.\d{3})*),(\d{2})\s?kr\b/g, out: function (m, i, d) { return i + ',' + d + NBSP + 'kr'; } }
  ];
  var set = rules[loc];
  if (!set) return;

  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1, CODE: 1 };

  function fixNode(node) {
    var t = node.nodeValue;
    if (!t || !/\d/.test(t)) return;
    var n = t;
    for (var k = 0; k < set.length; k++) n = n.replace(set[k].re, set[k].out);
    if (n !== t) node.nodeValue = n;
  }

  function fixAttrs(root) {
    var els = root.querySelectorAll ? root.querySelectorAll('[aria-label], [title], [data-price-label]') : [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i], names = ['aria-label', 'title'];
      for (var j = 0; j < names.length; j++) {
        var v = el.getAttribute(names[j]);
        if (!v || !/\d/.test(v)) continue;
        var n = v;
        for (var k = 0; k < set.length; k++) n = n.replace(set[k].re, set[k].out);
        if (n !== v) el.setAttribute(names[j], n);
      }
    }
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixNode(root); return; }
    if (root.nodeType !== 1 || SKIP[root.tagName]) return;
    fixAttrs(root);
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return n.parentNode && SKIP[n.parentNode.tagName] ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; }
    });
    var list = [], cur;
    while ((cur = w.nextNode())) list.push(cur);
    for (var i = 0; i < list.length; i++) fixNode(list[i]);
  }

  var pending = false, queue = [];
  function flush() {
    pending = false;
    var q = queue; queue = [];
    for (var i = 0; i < q.length; i++) walk(q[i]);
  }
  function schedule(node) {
    queue.push(node);
    if (!pending) { pending = true; (window.requestAnimationFrame || setTimeout)(flush); }
  }

  function start() {
    walk(document.body);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'characterData') schedule(m.target);
        else for (var j = 0; j < m.addedNodes.length; j++) schedule(m.addedNodes[j]);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
